module.exports = __webpack_public_path__ + "img/570-42dfb3.png";